var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"rd-panel",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('h4',{staticClass:"font-weight-bold"},[_vm._v(" Аналитика по топливу ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }